import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// Validates that the password confirmation input matches the password input
export function passwordConfirmationMatchesValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const passwordControl = formGroup.get(controlName);
    const confirmPasswordControl = formGroup.get(matchingControlName);

    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordConfirmationMatchesValidator']) {
      return null;
    }

    if (passwordControl.value !== confirmPasswordControl.value) {
      confirmPasswordControl.setErrors({ passwordConfirmationMatchesValidator: true });
      return { passwordConfirmationMatchesValidator: true };
    } else {
      confirmPasswordControl.setErrors(null);
    }

    return null;
  };
}
